import { AbstractControl, FormGroup } from '@angular/forms';

type FormControls = Record<string, AbstractControl<any>>;
export type FormGroupType<T> = FormGroup<{ [K in keyof T]: AbstractControl<T[K]> }>;

export function createFormGroup<T>(controls: FormControls = {}): FormGroup<{ [K in keyof T]: AbstractControl<T[K]> }> {
  return new FormGroup<any>(controls);
}
